// Vite's `?raw` suffix inlines the file's text at build time. The docs are real
// `.md` files in the repo, so they stay readable — and greppable — outside the
// app, which is most of the point of writing them.
import coderbyteDoc from './content/coderbyte.md?raw';

/** A recorded walkthrough shown above a doc. */
export type DocVideo = {
  /** Loom's `/embed/` URL, which is the one an iframe can load. */
  embedUrl: string;
  /** The `/share/` URL, for opening it in a tab of its own. */
  shareUrl: string;
  /** Names the frame for screen readers, so it is not "unnamed iframe". */
  title: string;
};

export type DocPage = {
  /** URL segment, also the filename without its extension. */
  slug: string;
  title: string;
  /** One line for the sidebar and the index. */
  summary: string;
  markdown: string;
  /**
   * Held here rather than as an `<iframe>` in the markdown itself: these pages
   * render through `ReactMarkdown` without `rehype-raw`, so embedded HTML is
   * dropped — and dropped silently, which is the worst way for a video to go
   * missing. Keeping it as data also leaves the `.md` file readable outside the
   * app, which is most of the point of writing them as files.
   */
  video?: DocVideo;
};

export const DOC_PAGES: DocPage[] = [
  {
    slug: 'coderbyte',
    title: 'Coderbyte',
    summary: 'Setting a company up with coding assessments.',
    markdown: coderbyteDoc,
    video: {
      embedUrl: 'https://www.loom.com/embed/d7c6877a3b0149cfafcdbc8bd2afb728',
      shareUrl: 'https://www.loom.com/share/d7c6877a3b0149cfafcdbc8bd2afb728',
      title: 'Setting a company up with Coderbyte',
    },
  },
];

export function findDocPage(slug: string | undefined): DocPage | undefined {
  if (!slug) return undefined;

  // `/docs/coderbyte.md` resolves to the same page as `/docs/coderbyte`, so a
  // link written with the real filename still works.
  const normalised = slug.replace(/\.md$/i, '');

  return DOC_PAGES.find(page => page.slug === normalised);
}
